import { Link } from "gatsby";
import React from "react";
import { fontsName } from "../../assets/fonts/fontsName";
import shape1 from "../../assets/images/shape/shape1.svg";
import shape2 from "../../assets/images/shape/shape2.png";
import shape3 from "../../assets/images/shape/shape3.png";
import news from "../../assets/images/main-banner/news.png";
import chart from "../../assets/images/main-banner/chart.png";
import about from "../../assets/images/main-banner/sch-about.png";
import feature from "../../assets/images/main-banner/features.png";

const PageBanner = ({
  pageTitle,
  homePageUrl,
  homePageText,
  activePageText,
}) => {
  let imageBanner;
  const isBrowser = typeof window !== "undefined";

  if (isBrowser) {
    if (window.location.pathname.indexOf("/site/news") !== -1) {
      imageBanner = (
        <img
          className="img-video-banner"
          src={news}
          alt="banner"
        // style={{width:"500px",position:"absolute",top:"12%",left:"20%",zIndex:"100"}}
        />
      );
    } else if (window.location.pathname.indexOf("/site/chart") !== -1) {
      imageBanner = (
        <img className="img-video-banner" id="app" src={chart} alt="banner" />
      );
    } else if (window.location.pathname.indexOf("/site/about-us") !== -1) {
      imageBanner = (
        <img className="img-video-banner" id="about" src={about} alt="banner" />
      );
    } else if (window.location.pathname.indexOf("/site/features") !== -1) {
      imageBanner = (
        <img
          className="img-video-banner"
          id="about"
          src={feature}
          alt="banner"
        />
      );
    }
  }
  return (
    <div className="video-banner-div">
      {imageBanner}
      <div className="page-title-area">
        <div className="container">
          <div className="page-title-content">
            <h2 style={{ fontFamily: fontsName.VazirBold }}>{pageTitle}</h2>
            <ul style={{ fontFamily: fontsName.Vazir }}>
              <li>{homePageText}</li>
              <li>
                <Link to={homePageUrl}>{activePageText}</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* <div style={{textAlign:"center",display:"flex",justifyContent:"center"}}> */}
        {/* </div> */}

        <div className="shape-img1">
          <img src={shape1} alt="banner" />
        </div>
        <div className="shape-img2">
          <img src={shape2} alt="banner" />
        </div>
        <div className="shape-img3">
          <img src={shape3} alt="banner" />
        </div>
      </div>
    </div>
  );
};

export default PageBanner;
